export function saveInStorage(key, value) {
	localStorage.setItem(window.btoa(key), window.btoa(value));
}

export function getFromStorage(key) {
	const item = localStorage.getItem(window.btoa(key));
	return item ? window.atob(item) : "";
}

export function removeItemFromStorage(key) {
	localStorage.removeItem(window.btoa(key));
}

export function clearStorage() {
	localStorage.clear();
}
